/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtDayParam } from './CourtDayParam';
import {
    CourtDayParamFromJSON,
    CourtDayParamFromJSONTyped,
    CourtDayParamToJSON,
    CourtDayParamToJSONTyped,
} from './CourtDayParam';

/**
 * 
 * @export
 * @interface CreateCourtRequest
 */
export interface CreateCourtRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    shortCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    fileNumberPrefix: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCourtRequest
     */
    country: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateCourtRequest
     */
    districts: Array<number>;
    /**
     * 
     * @type {Array<CourtDayParam>}
     * @memberof CreateCourtRequest
     */
    courtDays: Array<CourtDayParam>;
}

/**
 * Check if a given object implements the CreateCourtRequest interface.
 */
export function instanceOfCreateCourtRequest(value: object): value is CreateCourtRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('shortCode' in value) || value['shortCode'] === undefined) return false;
    if (!('fileNumberPrefix' in value) || value['fileNumberPrefix'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('districts' in value) || value['districts'] === undefined) return false;
    if (!('courtDays' in value) || value['courtDays'] === undefined) return false;
    return true;
}

export function CreateCourtRequestFromJSON(json: any): CreateCourtRequest {
    return CreateCourtRequestFromJSONTyped(json, false);
}

export function CreateCourtRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCourtRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'shortCode': json['shortCode'],
        'fileNumberPrefix': json['fileNumberPrefix'],
        'zipCode': json['zipCode'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'city': json['city'],
        'country': json['country'],
        'districts': json['districts'],
        'courtDays': ((json['courtDays'] as Array<any>).map(CourtDayParamFromJSON)),
    };
}

export function CreateCourtRequestToJSON(json: any): CreateCourtRequest {
    return CreateCourtRequestToJSONTyped(json, false);
}

export function CreateCourtRequestToJSONTyped(value?: CreateCourtRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortCode': value['shortCode'],
        'fileNumberPrefix': value['fileNumberPrefix'],
        'zipCode': value['zipCode'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'city': value['city'],
        'country': value['country'],
        'districts': value['districts'],
        'courtDays': ((value['courtDays'] as Array<any>).map(CourtDayParamToJSON)),
    };
}

